import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card } from '../../components/ui/card';
import { Smartphone, HardDrive, Shield, List, Clipboard } from 'lucide-react';
import SimCards from './SimCards';
import SimStatusLog from './SimStatusLog';

const TABS = [
  { key: 'sim-cards', label: 'Sim Cards', icon: Smartphone },
  { key: 'digital-boxes', label: 'Digital Boxes', icon: HardDrive },
  { key: 'ppe', label: 'PPE', icon: Shield },
];

const SIM_SUBTABS = [
  { key: 'inventory', label: 'Inventory', icon: List },
  { key: 'status-log', label: 'Sim Status Log', icon: Clipboard },
];

const EmptyTab = ({ title, description }) => (
  <Card className="p-10 text-center bg-slate-50/50">
    <p className="text-sm text-slate-500 font-medium">{title}</p>
    <p className="text-xs text-slate-400 mt-1">{description}</p>
  </Card>
);

const Inventory = ({ user }) => {
  const [params, setParams] = useSearchParams();
  const initial = params.get('tab') || 'sim-cards';
  const initialSub = params.get('sub') || 'inventory';
  const [active, setActive] = useState(initial);
  const [activeSub, setActiveSub] = useState(initialSub);

  const setTab = (k) => {
    setActive(k);
    setParams({ tab: k, sub: 'inventory' });
    setActiveSub('inventory');
  };
  const setSub = (k) => {
    setActiveSub(k);
    setParams({ tab: active, sub: k });
  };

  return (
    <div className="p-4 sm:p-6 space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Inventory</h1>
        <p className="text-sm text-slate-500">SIM cards, digital boxes &amp; PPE — assignment &amp; lifecycle history</p>
      </div>

      {/* Tab pills */}
      <div className="flex flex-wrap gap-1 border-b border-slate-200" data-testid="inventory-tabs">
        {TABS.map(t => {
          const Icon = t.icon;
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              data-testid={`inventory-tab-${t.key}`}
              className={`flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
                isActive
                  ? 'border-lime-600 text-lime-700 bg-lime-50/40'
                  : 'border-transparent text-slate-600 hover:text-slate-800 hover:bg-slate-50'
              }`}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </button>
          );
        })}
      </div>

      {/* Inner sub-tabs for Sim Cards only */}
      {active === 'sim-cards' && (
        <div className="flex flex-wrap gap-1 px-1 -mt-1" data-testid="sim-cards-subtabs">
          {SIM_SUBTABS.map(s => {
            const Icon = s.icon;
            const isActive = activeSub === s.key;
            return (
              <button
                key={s.key}
                onClick={() => setSub(s.key)}
                data-testid={`sim-subtab-${s.key}`}
                className={`flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-full border transition-colors ${
                  isActive
                    ? 'bg-blue-600 text-white border-blue-600'
                    : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'
                }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {s.label}
              </button>
            );
          })}
        </div>
      )}

      <div className="pt-2">
        {active === 'sim-cards' && activeSub === 'inventory' && <SimCards user={user} />}
        {active === 'sim-cards' && activeSub === 'status-log' && <SimStatusLog />}
        {active === 'digital-boxes' && <EmptyTab title="Digital Boxes" description="Coming soon" />}
        {active === 'ppe' && <EmptyTab title="PPE Inventory" description="Coming soon" />}
      </div>
    </div>
  );
};

export default Inventory;
